import PropTypes from 'prop-types';

const BlogContentShape = PropTypes.shape({
  count: PropTypes.number,
  description: PropTypes.string,
  id: PropTypes.number,
  link: PropTypes.string,
  name: PropTypes.string,
  'resy:related': PropTypes.arrayOf(PropTypes.shape({
    author_archive: PropTypes.string,
    author_display_name: PropTypes.string,
    authors: PropTypes.arrayOf(PropTypes.shape({
      author_archive: PropTypes.string,
      author_display_name: PropTypes.string,
    })),
    image: PropTypes.shape({
      title: PropTypes.string,
      alt: PropTypes.string,
      sizes: {
        'resy-lg': {
          height: PropTypes.number,
          url: PropTypes.string,
          width: PropTypes.number,
        },
        'resy-md': {
          height: PropTypes.number,
          url: PropTypes.string,
          width: PropTypes.number,
        },
        'resy-xl': {
          height: PropTypes.number,
          url: PropTypes.string,
          width: PropTypes.number,
        },
      },
    }),
    kicker_title: PropTypes.string,
    kicker_url: PropTypes.string,
    post_date: PropTypes.string,
    short_description: PropTypes.string,
    title: PropTypes.string,
    title_short: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
  })),
  slug: PropTypes.string,
  taxonomy: PropTypes.string,
});

export default BlogContentShape;
